module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/iowa-state-b13cc68c6043aa87dbc685a6e828ab08.svg";